<template>
  <el-dialog
  :title="title"
  :visible.sync="dialogVisible"
  width="30%"
  :before-close="handleClose">
  <slot></slot>
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="confirm">{{confirmText}}</el-button>
  </span>
</el-dialog>
</template>
<script>

export default {
  name:'vertifyDialog',
  props:{
    title: String,
    confirmText: String,
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    confirm(){
      this.$emit('confirm')
    },
    handleClose(){
      this.$emit('handleClose')
    }
  }
}
</script>
<style scoped>
>>> .el-dialog--small {
  width: 30%;
  min-width: 300px;
}
>>> .el-dialog__footer{
  border-top: 1px solid #f2f4f8;
  text-align: center;
}
>>> .el-dialog__body{
  padding: 15px 20px;
}
>>> .el-dialog__header{
  border-bottom: 1px solid #f2f4f8;
  padding: 12px;
}
>>> .el-button--primary {
  background-color:#09ad95;
  border-color: #09ad95;
}
</style>



// WEBPACK FOOTER //
// vertifyDialog.vue?99372f0c